import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import getText from '../../assets/locale/locale';
import LocaleContext from '../../contexts/LocaleContext';
import './ErrorPage.scss';
import ErrorPageProps from '~types/pages/ErrorPageProps';


const ErrorPage = (props: ErrorPageProps) => {
  const { quizIsStarted, resetWelcomePage, notFound } = props;
  const locId = useContext(LocaleContext);
  const location = useLocation(); 

	return (
  <div className="ErrorPage">
    <div className="ErrorPage_message">
      {notFound ? (
        <>
          <p id="heading-no-focus">{getText(locId, 'fourOhFour', 'errorPage')}</p>
          <div className="ErrorPage_welcome-page-link">
            <p>
              {getText(locId, 'returnToWelcomePage', 'errorPage')}
              <Link data-testid="welcome-page-link" to={{pathname: '/', search: location.search}} onClick={() => resetWelcomePage()}>{getText(locId, 'welcomePageLinkText', 'errorPage')}</Link>
              .
            </p>
          </div>
        </>
    ):
      (
        <>
          <p id="heading-no-focus">{`${getText(locId, 'errorTextLine1', 'errorPage')}`}</p>
          <p>{`${getText(locId, 'errorTextLine2', 'errorPage')}`}</p>
        </>
      )}
      {quizIsStarted ? (
        <div className="ErrorPage_welcome-page-link">
          <p>
            {getText(locId, 'returnToWelcomePage', 'errorPage')}
            <Link data-testid="welcome-page-link" to={{pathname: '/', search: location.search}} onClick={() => resetWelcomePage()}>{getText(locId, 'welcomePageLinkText', 'errorPage')}</Link>
            .
          </p>
        </div>
			) : null}
    </div>
  </div>
	);
};

ErrorPage.propTypes = {
	quizIsStarted: PropTypes.bool.isRequired,
  resetWelcomePage: PropTypes.func.isRequired,
  notFound: PropTypes.bool
};

ErrorPage.defaultProps = {
  notFound: false
};

export default ErrorPage;